"use client"

import { useNavigate } from "react-router-dom"

const NotFound404 = () => {
  const navigate = useNavigate()

  return (
    <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="text-center">
        <h1 className="display-1 fw-bold">404</h1>
        <h2 className="mb-4">Company Not Found</h2>
        <p className="text-muted mb-5">The company you're looking for doesn't exist or has been removed.</p>
        <button className="btn btn-primary" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  )
}

export default NotFound404
